import React from 'react';
import {OtherPersonsList} from '../../speaker/OtherPersonsList';
import * as yup from 'yup';
import {
    createContactSchemaFromPersonDataConfig,
    createPCOPersonDataSchemaFromPersonDataConfig
} from '../../speaker/PersonDataForm';

function OtherPersonsWidget({widget, formikProps, roles, disabled}) {
    return (
        <OtherPersonsList
            widgetId={widget.id}
            formikProps={formikProps}
            personDataConfig={widget.personDataConfig}
            roles={roles}
            disabled={disabled}
        />
    )
}

export function type() {
    return 'other_persons';
}

export function initialValue(widget) {
    return [];
}

/**
 * @param widget
 * @param allowPartialSubmissions
 * @returns {NotRequiredArraySchema<{role: object, person: {mainContact: {} | undefined} | undefined} | undefined, object>}
 */
export function schema(widget, allowPartialSubmissions) {
    return yup.array().of(
        yup.object().shape({
                person: yup.object().shape({
                    mainContact: yup.object().shape(createContactSchemaFromPersonDataConfig(widget.personDataConfig)),
                    pcoPersonData: yup.object().shape(createPCOPersonDataSchemaFromPersonDataConfig(widget.personDataConfig)).nullable()
                }),
                role: yup.object().nullable().required()
            }
        )
    )
}

/**
 * liest den Wert aus der Paper Submission aus und gibt ihn zurück
 * Das wird benötigt, um die Form zu initialisieren
 * @param callForPapers
 * @param widget
 * @param submission
 * @returns {*}
 */
export function submissionValue(callForPapers, widget, submission) {
    return submission.otherPersons;
}

export function component() {
    return OtherPersonsWidget;
}
